var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState, useEffect } from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import InputComponent from "../InputComponent";
// shared-library
import { floatNumExp } from "@frameworks/web/utils/regex";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import EmpPartnerSearch from "@frameworks/NCD/Components/EmpPartnerSearch";
import { useSelector } from "react-redux";
var PurchaseFee = function (_a) {
    var isModifyCta = _a.isModifyCta;
    var _b = __read(useState(false), 2), isInvalid = _b[0], setIsInValid = _b[1];
    var cActions = new actions();
    var purchaseFee = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).purchaseFee;
    var orderBookDetails = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }).orderBookDetails;
    var orderDetailsLocal = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data;
    var handleOnChangeInputs = useCallback(function (name, value) {
        var parsedValue = value.trim();
        var updatedValues = __assign({}, purchaseFee);
        if (name === "passout") {
            if (!isNaN(Number(parsedValue)) &&
                Number(parsedValue) >= 0 &&
                Number(parsedValue) <= 100) {
                parsedValue = parsedValue.toString();
                updatedValues[name] = parsedValue;
            }
            else {
                updatedValues[name] = "";
            }
        }
        else if (name === "sbName") {
            updatedValues[name] = parsedValue;
        }
        cActions.updateTransactionFeeValueProp(updatedValues);
    }, [purchaseFee]);
    useEffect(function () {
        var numValue = Number(purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout);
        if (!isNaN(numValue) && (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) !== "") {
            if (numValue >= 10 && numValue <= 85) {
                setIsInValid(false);
            }
            else {
                setIsInValid(true);
            }
        }
    }, [purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout]);
    useEffect(function () {
        if ((orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) &&
            (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_code)) {
            cActions.updateTransactionFeeValueProp(__assign(__assign({}, purchaseFee), { sbName: {
                    display_code: orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_code,
                    display_name: orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.sb_name,
                    display_type: "P",
                } }));
        }
    }, [orderDetailsLocal]);
    return (React.createElement("div", { className: "d-flex gap-3 flex-column aif-pms-order-book" },
        React.createElement(EmpPartnerSearch, { onSelectClient: function (item) {
                cActions.updateTransactionFeeValueProp(__assign(__assign({}, purchaseFee), { sbName: item }));
                cActions.updateValidSetUpFess(false);
            }, isModifyCta: isModifyCta }),
        React.createElement(InputComponent, { label: "Passout %", placeholder: "Enter Passout", helperText: "Between 10% - 85% of Spread Revenue", name: "passout", value: (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent)
                ? (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent) === "null"
                    ? ""
                    : orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.passout_user_percent
                : (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) === "null"
                    ? ""
                    : purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout, info: true, maxLength: 5, float: floatNumExp(2), onChangeEvent: function (event) {
                var _a, _b;
                var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                handleOnChangeInputs("passout", value);
                cActions.updateValidSetUpFess(false);
            }, isInvalid: isInvalid, errorText: "Oops! That number is out of bounds \u2014 please choose a value between 10 and 85.", passErrorTextButHideErrTxt: true, toolTipText: "SB Payout % must be between 10% and 85% of the Spread Revenue.", isModifyCta: isModifyCta, disabled: isModifyCta })));
};
export default PurchaseFee;
